import { render, staticRenderFns } from "./ModalAddTabelaProfissional.vue?vue&type=template&id=24c74bd4"
import script from "./ModalAddTabelaProfissional.vue?vue&type=script&lang=ts"
export * from "./ModalAddTabelaProfissional.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports